import { isPlausibleFbc } from "@/lib/attribution/browser-ids"

export const FBC_COOKIE_NAME = "_fbc"

/** Alinhado ao TTL usual do cookie `_fbc` do Meta Pixel (90 dias). */
export const FBC_COOKIE_MAX_AGE_SECONDS = 90 * 24 * 60 * 60

export function buildFbcSetCookieValue(
  fbc: string,
  maxAgeSeconds: number,
  isSecure: boolean,
): string {
  const encoded = encodeURIComponent(fbc.trim())
  const parts = [
    `${FBC_COOKIE_NAME}=${encoded}`,
    "path=/",
    `max-age=${Math.max(0, Math.trunc(maxAgeSeconds))}`,
    "SameSite=Lax",
  ]
  if (isSecure) parts.push("Secure")
  return parts.join("; ")
}

/** Persiste `_fbc` first-party quando construímos o valor (Pixel pode não ter gravado ainda). */
export function persistFbcDocumentCookie(fbc: string | null | undefined): void {
  if (typeof document === "undefined") return
  if (!isPlausibleFbc(fbc)) return

  let isSecure = false
  try {
    isSecure = window.location.protocol === "https:"
  } catch {
    // ignore
  }

  try {
    document.cookie = buildFbcSetCookieValue(
      fbc.trim(),
      FBC_COOKIE_MAX_AGE_SECONDS,
      isSecure,
    )
  } catch {
    // ignore
  }
}
